import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStart = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.00004 1.33331L9.34134 4.8207C9.52935 5.30952 9.62336 5.55393 9.76954 5.75952C9.8991 5.94173 10.0583 6.10092 10.2405 6.23048C10.4461 6.37666 10.6905 6.47067 11.1793 6.65868L14.6667 7.99998L11.1793 9.34128C10.6905 9.52929 10.4461 9.6233 10.2405 9.76948C10.0583 9.89904 9.8991 10.0582 9.76954 10.2404C9.62336 10.446 9.52935 10.6904 9.34135 11.1793L8.00004 14.6666L6.65874 11.1793C6.47073 10.6904 6.37673 10.446 6.23054 10.2404C6.10098 10.0582 5.94179 9.89904 5.75958 9.76948C5.55399 9.6233 5.30958 9.52929 4.82077 9.34128L1.33337 7.99998L4.82076 6.65868C5.30958 6.47067 5.55399 6.37666 5.75958 6.23048C5.94179 6.10092 6.10098 5.94173 6.23054 5.75952C6.37673 5.55393 6.47073 5.30952 6.65874 4.8207L8.00004 1.33331Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgStart;
